import {
  getAuthURL,
  getClickstreamBaseURL,
  getClientId,
  getEnv,
  getSize,
} from "./schemas/clickstream-util";

export const APP_NAME = "CES-UI";
export const USER_ID_STORAGE_IDENTIFIER = "userId";

export const MAX_EVENT_SIZE = 50;
let events = [];

export default function clickstreamInit() {
  window._csq = window._csq || [];
  events = [];

  initScriptTag();
  initCsqInfo();
}

function initScriptTag() {
  let script = document.createElement("script");
  script.async = true;
  script.src = "https://clickstreamjs.grubhub.com/1.2.17/clickstream2.min.js";
  let firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

function initCsqInfo() {
  let csq = window._csq;

  csq.userUdidKey = USER_ID_STORAGE_IDENTIFIER;
  csq.v2platform = {
    app: APP_NAME,
    appVersion: window.cesVersion,
    brand: "grubhub",
    env: getEnv(),
    deviceFamily: getSize(),
  };
  csq.v2host = getClickstreamBaseURL();
  csq.v2post = (url, data) => postEvents(url, data);
}

export async function getAccessToken() {
  const headers = {
    accept: "application/json, text/plain, */*",
    "content-type": "application/json;charset=UTF-8",
  };
  const body = JSON.stringify({
    brand: "GRUBHUB",
    scope: "anonymous",
    client_id: getClientId(),
  });

  return fetch(getAuthURL(), {
    method: "POST",
    headers,
    body,
  })
    .then((response) => response.json())
    .then((response) => response.session_handle.access_token);
}

export async function postEvents(url, data) {
  const token = await getAccessToken();
  events = [...events, ...data.events];

  if (!events.length || !token) {
    return;
  }

  let promises = [];

  while (events.length) {
    const eventsToBeSent = events.slice(0, MAX_EVENT_SIZE);
    const remainingEvents = events.slice(MAX_EVENT_SIZE);

    const opts = {
      method: "POST",
      body: JSON.stringify({ events: eventsToBeSent }),
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      },
    };

    let promise = fetch(url, opts).catch((err) => {
      if (!err || !err.status || err.status < 0) {
        events = [...eventsToBeSent, ...events];
        throw err;
      }
    });

    promises.push(promise);
    events = [...remainingEvents];
  }

  return Promise.all(promises);
}



// WEBPACK FOOTER //
// ./client/app/common/clickstream/clickstream-init.js